import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { UnAuthGuard } from "@core/guards/un-auth.guard";

const routes: Routes = [
    { path: "", pathMatch: "full", redirectTo: "login" },
    {
        path: "login",
        canLoad: [UnAuthGuard],
        loadChildren: () =>
            import("./modules/login/login.module").then(({ LoginModule }) => LoginModule),
    },
    {
        path: "register",
        canLoad: [UnAuthGuard],
        loadChildren: () =>
            import("./modules/register/register.module").then(
                ({ RegisterModule }) => RegisterModule
            ),
    },
    {
        path: "login-help",
        canLoad: [UnAuthGuard],
        loadChildren: () =>
            import("./modules/login-help/login-help.module").then(
                ({ LoginHelpModule }) => LoginHelpModule
            ),
    },
    {
        path: "support",
        canLoad: [UnAuthGuard],
        loadChildren: () =>
            import("./modules/support/support.module").then(({ SupportModule }) => SupportModule),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
